<template>
  <div class="container">
    <AppNavbar
      :placeholder="true"
      :options="options"
      :zIndex="20"
      title="活动规则"
    ></AppNavbar>
    <div class="rule">
      <div class="t-title">
        <div class="t-item">
          <div class="line"></div>
          <div class="dot"></div>
        </div>
        <div class="title">新人专享活动规则说明</div>
        <div class="t-item">
          <div class="dot"></div>
          <div class="line line-right"></div>
        </div>
      </div>
      <div class="rule-item">
        <div class="tips"
          >参与本次新人活动前，请您详细阅读并知悉本次活动规则及相关条款。凡参与本次活动，即视为用户已阅读、理解、并同意活动规则及特别提示的全部内容。</div
        >
      </div>
      <div class="rule-item">
        <div class="title-1">Part1：活动简介</div>
        <div class="t-content">
          <div class="t-text"
            >(1)
            您下载betterWE星球后，登录betterWE星球app，完成签到任务及新人日常任务，即可获得平台一定的积分奖励。</div
          >
          <div class="t-text"
            >(2)不同的任务奖励不同，完成任务后奖励会自动下发至你的账户，且奖励会根据参与情况实时调整，具体任务完成次数和具体奖励数额以活动页面展示为准。</div
          >
          <div class="t-text"
            >(3) 您可通过点击首页右上角“签到”等入口进入活动页面</div
          >
          <div class="t-text"
            >(4)
            部分功能可能处于试点阶段，您可能会有添加到企业微信的步骤，这是我们的官方运营人员，请放心添加领取奖励。</div
          >
          <div class="t-text"
            >(5)
            平台将根据本次活动的效果及运营能力等多方面因素决定积分能兑换的礼品，具体以活动页面展示为准。</div
          >
        </div>
      </div>
      <div class="rule-item">
        <div class="title-1">Part2：活动入口</div>
        <div class="t-text">(1) betterWE星球首页右上角“签到”入口</div>
        <img
          class="rule-image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e460e531bf041c8ce52bac4577bea20a.webp"
          alt=""
        />
      </div>
      <div class="rule-item">
        <div class="title-1">Part3：任务规则</div>
        <div class="title-2">3-1：签到规则</div>
        <div class="t-text"
          >(1)
          您可在活动页面点击【签到】即算完成签到任务，获得签到积分奖励。</div
        >
        <div class="t-text"
          >(2)
          连续签到：自首次完成签到开始累计，连续7天签到即完成整个签到任务，签到积分第一天5分，往后每日在前一日多加5分，并在第2、4、7天能获得额外的连签奖励。</div
        >
        <div class="t-text"
          >(3)
          断签：在7天的签到周期内，若您发生断签，则您的签到积分奖励重新开始计算，累计积分重新变为5，连签奖励将根据您的实际情况重新计算，具体根据活动页面展示的积分奖励为主。
        </div>
        <div class="t-text"
          >(4) 本次活动仅面向当日注册新用户，且仅能参与一次。</div
        >
        <div class="t-text"
          >(5) 开启签到右上角“签到提醒”可接收每日提醒推送通知。</div
        >
        <div class="title-2">3-2：任务规则</div>
        <div class="t-text"
          >(1)
          您登录betterWE星球app后，完成任务列表指定任务，平台将给予您对应的积分奖励，具体奖励以页面展示及发放为准。</div
        >
        <div class="t-text"
          >(2) 同一用户每日完成有限任务，所得奖励亦有上限。</div
        >
        <div class="t-text"
          >(3)
          “减脂第一站”板块任务属于特殊任务，该任务必须在活动周期内参与，否则下线后无法再次参与获得积分。</div
        >
        <div class="t-text"
          >(4)
          “营养知识库”板块任务每日流量内容不一，该任务必须每日完成，否则次日下线不可再进行任务补卡。</div
        >
        <div class="t-text"
          >(5)
          部分任务完成后，数据刷新可能会存在延迟，请稍后重新进入活动界面。</div
        >
        <img
          class="rule-image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/61b3ab29b6e5d56ca4936c475e500822.webp"
          alt=""
        />
      </div>
      <div class="rule-item">
        <div class="title-1">Part4：积分规则</div>
        <div class="t-text"
          >(1)
          完成以上任务后，您会获得对应的积分奖励，具体的奖励数额以您完成的任务页面展示为准。</div
        >
        <div class="t-text"
          >(2)获得的积分可以兑换相关礼品，您当日注册APP开启活动任务后获得的积分于次日0点可以开始进行兑换，当日不可兑换，若次日依然无法兑换，可通过邮箱反馈至<span
            style="color: rgba(48, 157, 255, 1)"
            >APPyunying@wegymer.com</span
          >，我们将于3个工作日之内与您取得联系。</div
        >
        <div class="t-text"
          >(3)
          请您及时进行积分兑换，部分礼品有每日限额兑换，您可关注后及时兑换，以免错过兑换时机；部分新人专属兑换商品为注册14日内限定，请于在注册14日内尽快使用积分兑换，过时不可使用。</div
        >
        <div class="t-text"
          >(4)
          所有在活动期间内领取到的额外奖励，有效期均为14天，您必须在14天内进行使用或兑换，过时不再补发。</div
        >
      </div>
      <div class="rule-item">
        <div class="title-1">特别提示</div>
        <div class="t-text"
          >(1)
          betterWE星球倡导公平参与活动，有违规行为的用户将取消参与资格，并取消获得的奖励。具体违规包括但不限于：侵犯第三人合法权益、使用具有作弊嫌疑的高危手机号、使用同一手机反复登录多个账号、篡改设备数据、使用模拟器、外挂、app分身软件等非法工具等。
        </div>
        <div class="t-text">
          (2)本平台依法运营此活动，如因不可抗力、相关政策或活动调整等原因，导致本活动调整、暂停举办或无法进行的，本平台有权随时决定修改、暂停、取消或者终止本活动，并无需为此承担任何法律责任。</div
        >
        <div class="t-text"
          >(3)
          活动期间内，用户卸载客户端或退出登录或关闭活动页面或更换账号登录设备，有可能导致已领取的奖励信息或正在进行的任务进度丢失，请谨慎操作。</div
        >
        <div class="t-text"
          >(4)
          活动期间内，因用户操作不当或用户所在地区网络故障、电信运营商故障、第三方平台限制等非本平台所能控制的原因导致用户无法参与活动或参与失败，本平台无需为此承担任何法律或经济责任。</div
        >
        <div class="t-text">(5) 本活动最终解释权归betterWE星球所有。</div>
      </div>
    </div>
  </div>
</template>
<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
export default {
  components: {
    AppNavbar
  },
  data() {
    return {
      options: {
        textAlign: 'left'
      }
    }
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.rule {
  padding: 30px 16px 36px;

  .tips {
    font-size: 12px;
    font-family: MiSans, MiSans;
    font-weight: 600;
    color: rgba(139, 55, 22, 0.6);
    line-height: 16px;
    margin-bottom: 26px;
  }

  .t-title {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 16px;

    .title {
      margin: 0 19px;
    }

    .t-item {
      display: flex;
      align-items: center;
      .dot {
        width: 5px;
        height: 5px;
        background: #bcada9;
        transform: rotate(45deg);
        transform-origin: center;
      }

      .line {
        width: 45px;
        height: 1.5px;
        opacity: 0.38;
        background: linear-gradient(
          270deg,
          rgba(92, 49, 31, 1),
          rgba(92, 49, 31, 0)
        );
      }
      .line-right {
        background: linear-gradient(
          90deg,
          rgba(92, 49, 31, 1),
          rgba(92, 49, 31, 0)
        );
      }
    }
  }

  .rule-item {
    margin-bottom: 26px;

    .title-1 {
      font-size: 17px;
      font-family: MiSans, MiSans;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 23px;
    }

    .t-text {
      font-size: 12px;
      font-family: MiSans, MiSans;
      color: rgba(0, 0, 0, 0.6);
      line-height: 18px;
    }

    .title-2 {
      margin-top: 12px;
      font-size: 14px;
      font-family: MiSans, MiSans;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.7);
      line-height: 19px;
    }

    .rule-image {
      margin-top: 6px;
      width: 100%;
    }

    .t-content {
      margin-top: 6px;
    }
  }
}
</style>
